import React, { useMemo, useState } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Col, Row } from '../../../components/base/BootstrapComponents';
import { responseLogWithNotification } from '../../../utils/utils';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { calculateTariffCost } from '../actions';
import { getTariffData } from '../reducer';

const formatRubles = value => {
  const rubles = Number(value || 0) / 100;
  if (Number.isNaN(rubles)) {
    return '0';
  }
  return Number.isInteger(rubles) ? String(rubles) : rubles.toFixed(2);
};

export default function TariffCostTestPage() {
  const dispatch = useDispatch();
  const { loadingTariffCostCalculation } = useSelector(getTariffData);
  const [result, setResult] = useState(null);
  const tz = window.localStorage.getItem('USER_TIME_ZONE') || moment.tz.guess();

  const defaultValues = useMemo(() => ({
    vehicle_type: 'car',
    start_time: moment.tz(tz).startOf('hour').toISOString(),
    end_time: moment.tz(tz).startOf('hour').add(2, 'hours').toISOString(),
  }), [tz]);

  const {
    control,
    getValues,
  } = useForm({
    defaultValues,
  });

  const vehicleTypeOptions = [
    { nameId: 'vehicle.type.car', value: 'car' },
    { nameId: 'vehicle.type.bus', value: 'bus' },
    { nameId: 'vehicle.type.motorcycle', value: 'motorcycle' },
    { nameId: 'vehicle.type.truck', value: 'truck' },
    { nameId: 'vehicle.type.all', value: 'all' },
  ];

  const handleCalculate = () => {
    const data = getValues();
    if (!moment(data.start_time).isValid() || !moment(data.end_time).isValid()) {
      notificationDecorator({
        title: 'Тест расчета тарифа',
        message: 'Заполните корректно дату и время начала и окончания.',
        isError: true,
      });
      return;
    }

    if (!moment(data.end_time).isAfter(moment(data.start_time))) {
      notificationDecorator({
        title: 'Тест расчета тарифа',
        message: 'Время окончания должно быть больше времени начала.',
        isError: true,
      });
      return;
    }

    dispatch(calculateTariffCost({
      start_time: data.start_time,
      end_time: data.end_time,
      tariff_type: 'single',
      vehicle_type: data.vehicle_type || 'car',
    }))
      .then(response => {
        setResult(response);
      })
      .catch(responseLogWithNotification);
  };

  return (
    <div className="tariff-tab tariff-test-page">
      <Loader global loading={loadingTariffCostCalculation} />
      <div className="page-container">
        <div className="inputs-box">
          <PageHeader header="Тестирование тарифа" />
        </div>
        <div className="plp-table g-0">
          <div className="frame tariff-test-frame">
            <div className="tariff-test-description">
              Укажите период и тип транспортного средства, чтобы заранее проверить стоимость парковки по текущим активным тарифам, рабочему календарю и дневным тарифам.
            </div>
            <Row>
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  type="text"
                  className="mb-2"
                  dtoObject={{
                    name: 'start_time',
                    type: String,
                    validators: {},
                    labelKey: 'tariff.test.start_time',
                  }}
                  addPlaceholder
                  component={DateTimePicker}
                  withLabel
                  onChangeToIso
                />
              </Col>
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  type="text"
                  className="mb-2"
                  dtoObject={{
                    name: 'end_time',
                    type: String,
                    validators: {},
                    labelKey: 'tariff.test.end_time',
                  }}
                  addPlaceholder
                  component={DateTimePicker}
                  withLabel
                  onChangeToIso
                />
              </Col>
              <Col columns={4}>
                <FieldDTO
                  control={control}
                  type="text"
                  className="mb-2"
                  dtoObject={{
                    name: 'vehicle_type',
                    type: String,
                    validators: {},
                    labelKey: 'tariff.test.vehicle_type',
                  }}
                  addPlaceholder
                  component={CustomSelectInput}
                  options={vehicleTypeOptions}
                  withLabel
                />
              </Col>
            </Row>
            <div className="tariff-test-actions">
              <Button onClick={handleCalculate}>Рассчитать стоимость</Button>
            </div>
            <div className="tariff-test-result">
              <div className="tariff-test-result-label">Предварительная стоимость</div>
              <div className="tariff-test-result-value">
                {result ? `${formatRubles(result.cost)} руб.` : 'Еще не рассчитана'}
              </div>
              <div className="tariff-test-result-note">
                Расчет выполняется через сервис тарифов и нужен для сервисного обслуживания и проверки корректности тарификации на парковке.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
